export class RandomStringGenerator {
  public static generateString(length: number, options: {
    numbers?: boolean,
    letters?: boolean,
    specialCharacters?: boolean,
    includeUppercase?: boolean,
  }): string {
    let result = '';
    const lowercase = 'abcdefjklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const specialCharacters = '!@#$%^&*()_+~`|}{[]\:;?><,./-=';
    const characters = (options.letters ? lowercase : '') + (options.includeUppercase ? uppercase : '') + (options.numbers ? numbers : '') + (options.specialCharacters ? specialCharacters : '');
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}


